import { useEffect } from 'react';

import { OFFICIAL_LIVE_CALLBACK_PROVIDER_STATE } from '@/lib/integrationCallbackState.js';

function useIntegrationStatusNotifications({ location, navigate, toast }) {
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const status = searchParams.get('integration_status');
        const providerKey = searchParams.get('integration_provider');
        const errorMessage = searchParams.get('integration_error');

        if (!status || !providerKey) {
            return;
        }

        const providerLabels = {
            twitch: 'Twitch',
            youtube: 'YouTube',
            youtube_live: 'YouTube Live',
            kick: 'Kick',
            trovo: 'Trovo',
            steam: 'Steam',
        };
        const providerLabel = providerLabels[providerKey] || providerKey;

        if (status === 'success') {
            toast({
                title: `${providerLabel} collegato`,
                description: `L'account ${providerLabel} è stato collegato correttamente.`,
            });
        } else {
            toast({
                title: `Collegamento ${providerLabel} non riuscito`,
                description: errorMessage || 'Ripeti il collegamento o controlla le impostazioni del provider.',
                variant: 'destructive',
            });
        }

        searchParams.delete('integration_status');
        searchParams.delete('integration_provider');
        searchParams.delete('integration_error');

        const preserveOfficialLiveProvider =
            location.pathname === '/gamedatamanager' && searchParams.get('tab') === 'officialLive';
        const navigationOptions = { replace: true };
        if (preserveOfficialLiveProvider) {
            navigationOptions.state = {
                ...(location.state || {}),
                [OFFICIAL_LIVE_CALLBACK_PROVIDER_STATE]: providerKey,
            };
        }

        navigate(
            {
                pathname: location.pathname,
                search: searchParams.toString() ? `?${searchParams.toString()}` : undefined,
                hash: location.hash,
            },
            navigationOptions
        );
    }, [location.pathname, location.search, location.hash, location.state, navigate, toast]);
}

export default useIntegrationStatusNotifications;
